let lendingFeePayTimeOptions = [
  {
    label: '第一期一次性收取',
    value: '第一期一次性收取'
  },
  {
    label: '分期收取',
    value: '分期收取'
  }
]

export default lendingFeePayTimeOptions



// WEBPACK FOOTER //
// ./src/utils/lendingFeePayTimeOptions.js